import * as actionTypes from '../constants/actionTypes';
var initialState = {
    orientation: null,
};
export default function deviceReducer(state, action) {
    if (state === void 0) { state = initialState; }
    switch (action.type) {
        case actionTypes.ORIENTATION_CHANGED:
            return { orientation: action.orientation };
        default:
            return state;
    }
}
